// 騎士の突き・薙ぎの足を留める版 (?knightSmooth=1028・src/knight_smooth_1028.ts) の、sprites.ts が読む切り替えだけを持つ (2026-10-28)。
//   sprites.ts から読むので、ほかを import しない (knight_smooth_1028.ts を直接読むと循環して起動で落ちる・介錯の exec_jab_tremble_1028.ts と同じ)。
//   入れるのは src/knight_smooth_1028.ts の setKnightSmooth。
import type { BossAttackTimeline } from './boss_pose_timeline'
import type { Boss } from './types'

let on = false
let links: Partial<Record<string, BossAttackTimeline>> = {}
let restShift: Partial<Record<string, number>> = {}
export function setKnightSmoothFlags(v: boolean, link: Partial<Record<string, BossAttackTimeline>>, shift: Partial<Record<string, number>>): void {
  on = v; links = link; restShift = shift
}

// 溜めの乱数の微振動と膨らみ (最大 5%) を足さない (突きと薙ぎだけ)。
//   膨らみは足元を中心に広げるので、溜めの間に足が外へ滑り、攻撃の頭で 1 に戻る1コマで穂先が跳ねる (介錯の 1028d と同じ)。
export function knightSmoothSkipsSwell(bossId: string, attackId: string | undefined): boolean {
  return on && bossId === 'vigil-knight' && (attackId === 'lanceThrust' || attackId === 'lanceSweep')
}

// 連の2拍目以降の突き・薙ぎ。溜めの絵は全部 lanceThrust_linkWindup / lanceSweep_linkWindup に差し替わる (comboNoNeutralImage) ので、
//   単発の並びの 入り (立ち姿→槍を下ろす絵→構え) のずらしを残すと、同じ絵が前後に行き来する。連では構えから入る並びを使う。
export function knightSmoothLinkTimeline(boss: Boss): BossAttackTimeline | undefined {
  const id = boss.currentAttack?.id
  if (!on || boss.id !== 'vigil-knight' || !id || !boss.currentString || (boss.beatIndex ?? 0) <= 0) return undefined
  return links[id]
}

// 足を寄せる絵の置き位置 (sprites.ts の KNIGHT_REST_ANCHOR_SHIFT_PX の上書き・原画 px)。1028 と rest の時だけ中身が入る。
export function knightSmoothRestShift(key: string): number | undefined {
  return restShift[key]
}

// 突きの後の拍間 (lanceDouble_gap) のずらし。拍間は recovery の頭のキー (伸び切りのずらし) を読むので、そのままだと前足が 26px 後ろへ跳ぶ。
//   当たる絵の前足に留める値 (五連の撮影で前足の差 12px) に置き換える。
export function knightSmoothGapOffsetX(image: string | undefined): number | undefined {
  return on && image === 'lanceDouble_gap' ? -12 : undefined
}
